import { useMutation } from '@tanstack/react-query';
import { camelizeKeys, decamelizeKeys } from 'humps';

import { useApiClient } from '../../../hooks';

export const useFindEntityMatchesMutation = (accessToken) => {
  const apiClient = useApiClient(accessToken);

  return useMutation(async ({ data, organizationId }) => {
    const response = await apiClient.post(`/sync/entities/find`, decamelizeKeys(data), {
      params: decamelizeKeys({ organizationId })
    });

    return camelizeKeys(response.data);
  });
};
